module.exports = __webpack_public_path__ + "img/fair_catch.22154e0e.jpg";